import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 26 16"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    x1: "83.8040865%",
                    y1: "50%",
                    x2: "-1.11022302e-14%",
                    y2: "50%",
                    id: "linearGradient-1",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#50D0B7",
                            offset: "0%"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#00C3FF",
                            offset: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                id: "页面-1",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ _jsx("g", {
                    id: "iPhone-SE",
                    transform: "translate(-702.000000, -549.000000)",
                    fill: "url(#linearGradient-1)",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ _jsx("g", {
                        id: "编组-3",
                        transform: "translate(375.000000, 170.000000)",
                        children: /*#__PURE__*/ _jsx("g", {
                            id: "编组-4",
                            transform: "translate(24.000000, 115.040181)",
                            children: /*#__PURE__*/ _jsx("g", {
                                id: "编组-6",
                                transform: "translate(0.000000, 258.000000)",
                                children: /*#__PURE__*/ _jsx("path", {
                                    d: "M324.46865,6.77364506 C324.984414,6.25788169 325.606093,6 326.333688,6 C327.061282,6 327.682961,6.25788169 328.198725,6.77364506 C328.732908,7.28940843 329,7.90648247 329,8.62486716 C329,9.34325186 328.732908,9.96032589 328.198725,10.4760893 L317.865037,20.7545165 C317.643996,21.0123982 317.367694,21.1919943 317.036132,21.293305 C316.70457,21.3946157 316.354587,21.4360609 315.986185,21.4176408 C315.617783,21.3992207 315.253985,21.3209352 314.894793,21.1827843 C314.5356,21.0446334 314.227063,20.8466171 313.969182,20.5887354 L303.801275,10.4760893 C303.267092,9.96032589 303,9.34325186 303,8.62486716 C303,7.90648247 303.267092,7.28940843 303.801275,6.77364506 C304.059157,6.51576337 304.349274,6.32235211 304.671626,6.19341126 C304.993978,6.06447042 305.32554,6 305.666312,6 C306.007085,6 306.343252,6.06447042 306.674814,6.19341126 C307.006376,6.32235211 307.301098,6.51576337 307.55898,6.77364506 L316.013815,15.1179596 L324.46865,6.77364506 Z",
                                    id: "H5_icon_xiala",
                                    transform: "translate(316.000000, 13.710946) scale(-1, -1) translate(-316.000000, -13.710946) "
                                })
                            })
                        })
                    })
                })
            })
        ]
    }));
};
export default Icon;
